import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Heart } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/udyami-mitra-logo.png" 
                alt="उद्यमी मित्र - System of Success" 
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed">
              भारतीय उद्यमियों के लिए विस्तृत प्रोजेक्ट रिपोर्ट (DPR) प्रदान करने वाला प्लेटफॉर्म। 
              PMEGP, MUDRA और बैंक लोन के लिए आदर्श।
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-rajdhani font-bold text-lg text-gray-800 mb-4">त्वरित लिंक</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  प्रोजेक्ट्स देखें
                </Link>
              </li>
              <li>
                <Link to="/suppliers" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  सप्लायर खोजें
                </Link>
              </li>
              <li>
                <Link to="/supplier-registration" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  सप्लायर बनें
                </Link>
              </li>
              <li>
                <Link to="/request-project" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  नया प्रोजेक्ट रिक्वेस्ट
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-rajdhani font-bold text-lg text-gray-800 mb-4">कानूनी</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  नियम और शर्तें
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  गोपनीयता नीति
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  रिफंड नीति
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  शिपिंग / डिलीवरी
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-rajdhani font-bold text-lg text-gray-800 mb-4">संपर्क करें</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-orange-500 mt-0.5" />
                <div>
                  <a href="mailto:info@udyamimitra.org" className="text-orange-500 hover:text-orange-600 transition-colors text-sm">
                    info@udyamimitra.org
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-orange-500 mt-0.5" />
                <a href="tel:+919826618603" className="text-gray-600 hover:text-orange-500 text-sm">+91 98266 18603</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-orange-500 mt-0.5" />
                <span className="text-gray-600 text-sm">112, Samvid Nagar, Kanadiya Road, Indore - 452016 (M.P.)</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-xs text-gray-500 mb-3">हमें फॉलो करें</p>
              <div className="flex gap-3">
                <a href="#" className="p-2 bg-white rounded-lg border border-gray-200 hover:border-orange-300 hover:bg-orange-50 transition-colors">
                  <Facebook className="w-4 h-4 text-gray-500 hover:text-orange-500" />
                </a>
                <a href="#" className="p-2 bg-white rounded-lg border border-gray-200 hover:border-orange-300 hover:bg-orange-50 transition-colors">
                  <Twitter className="w-4 h-4 text-gray-500 hover:text-orange-500" />
                </a>
                <a href="#" className="p-2 bg-white rounded-lg border border-gray-200 hover:border-orange-300 hover:bg-orange-50 transition-colors">
                  <Instagram className="w-4 h-4 text-gray-500 hover:text-orange-500" />
                </a>
                <a href="#" className="p-2 bg-white rounded-lg border border-gray-200 hover:border-orange-300 hover:bg-orange-50 transition-colors">
                  <Linkedin className="w-4 h-4 text-gray-500 hover:text-orange-500" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} Udyami Mitra. A unit of <span className="text-gray-700 font-medium">System of Success</span>. सर्वाधिकार सुरक्षित।
            </p>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-500 fill-red-500" />
              <span>in India</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
